import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SelectProTypePage } from './select-pro-type.page';

const routes: Routes = [
  {
    path: '',
    component: SelectProTypePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SelectProTypePageRoutingModule {}
